import { Injectable } from '@angular/core';
import { LU_MaterialSubCategoryServiceBase } from 'scaletech-tickets';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class LU_MaterialSubCategoryService extends LU_MaterialSubCategoryServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
